<template>
    <div class="container container-tabs">
        <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
            <el-tab-pane name="all" class="to-searh">
                <span slot="label" class="table-title">全部</span>
            </el-tab-pane>

            <el-tab-pane :name="String(item.val)" v-for="(item, index) in value_status_array" :key="index" class="to-searh">
                <span slot="label" class="table-title">{{ item.alias }}</span>
            </el-tab-pane>

            <div class="handle-box">
                <el-row class="head-search">
                    <el-col :span="8">
                        <span class="title">司机名称:</span>
                        <!-- 搜索司机名称-->
                        <el-input
                            v-model="search_data.name"
                            placeholder="请输入司机名称"
                            class="handle-input mr10"
                            @keyup.enter.native="searchDriverLists"
                        ></el-input>
                    </el-col>

                    <el-col :span="8">
                        <span class="title">手机号码:</span>
                        <!-- 搜索手机号码 -->
                        <el-input
                            v-model="search_data.phone"
                            placeholder="请输入手机号码"
                            class="handle-input mr10"
                            maxlength="11"
                            @keyup.enter.native="searchDriverLists"
                        >
                        </el-input>
                    </el-col>

                    <el-col :span="6">
                        <el-button :class="more_search ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" @click="more_search = !more_search">
                            详细搜索
                        </el-button>
                    </el-col>
                </el-row>

                <el-row class="head-search">
                    <el-col :span="8">
                        <span class="title">真实姓名:</span>
                        <!-- 搜索司机名称-->
                        <el-input
                            v-model="search_data.real_name"
                            placeholder="请输入真实姓名"
                            class="handle-input mr10"
                            @keyup.enter.native="searchDriverLists"
                        ></el-input>
                    </el-col>
                    <el-col :span="8">
                        <span class="title">身份证号:</span>
                        <!-- 搜索司机名称-->
                        <el-input
                            v-model="search_data.id_card"
                            placeholder="请输入身份证号"
                            class="handle-input mr10"
                            @keyup.enter.native="searchDriverLists"
                        ></el-input>
                    </el-col>
                </el-row>

                <div v-show="more_search" style="margin-top: 10px">
                    <!-- 搜索性别 -->
                    <el-row class="head-search">
                        <el-col :span="24" style="margin: 10px 0">
                            <span class="title">性别:</span>
                            <el-radio-group v-model="search_data.sex" size="small">
                                <el-radio label="" border> 全部 </el-radio>
                                <el-radio v-for="(item, index) in val_sex_array" :key="index" :label="String(item.val)" border>
                                    {{ item.alias }}
                                </el-radio>
                            </el-radio-group>
                        </el-col>
                    </el-row>

                    <el-row class="head-search">
                        <el-col :span="24" style="margin: 10px 0">
                            <span class="title">司机警示灯:</span>
                            <el-radio-group v-model="search_data.insurance_alarm" size="small">
                                <el-radio label="" border> 全部 </el-radio>
                                <el-radio label="1" border> 黄 </el-radio>
                                <el-radio label="2" border> 红 </el-radio>
                            </el-radio-group>
                        </el-col>
                    </el-row>
                </div>
            </div>

            <div>
                <el-button type="primary" icon="el-icon-search" @click="searchDriverLists">搜索</el-button>
                <!-- <el-button @click="add_isShow=!add_isShow">添加</el-button> -->
                <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
                <!-- <el-button @click="exportData">导出司机业绩</el-button> -->
            </div>
        </el-tabs>

        <!-- 表格 -->
        <el-table
            :data="tableData"
            style="width: 100%"
            ref="multipleTable"
            header-cell-class-name="table-header"
            @selection-change="handleSelectionChange"
        >
            <!-- <el-table-column type="selection" width="55" align="center" prop="driver_code"></el-table-column> -->
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-form label-position="left" inline class="demo-table-expand">
                        <div class="more-style">
                            <el-form-item label="创建时间:">
                                <span>{{ props.row.reg_time.Ymd }}</span>
                            </el-form-item>
                            <el-form-item label="创建详细时间:">
                                <span>{{ props.row.reg_time.YmdHis }}</span>
                            </el-form-item>
                            <el-form-item label="更改时间:">
                                <span>{{ props.row.edit_time.YmdHis }}</span>
                            </el-form-item>
                        </div>
                        <div class="more-style">
                            <el-form-item label="更改详细时间:">
                                <span>{{ props.row.edit_time.YmdHis }}</span>
                            </el-form-item>
                            <el-form-item label="app版本:">
                                <span>{{ props.row.app_version }}</span>
                            </el-form-item>
                            <el-form-item label="注册来源:">
                                <span>{{ props.row.reg_from }}</span>
                            </el-form-item>
                        </div>

                        <div class="more-style">
                            <el-form-item label="紧急联系人:">
                                <span>{{ props.row.urgent_name }}</span>
                            </el-form-item>
                            <el-form-item label="紧急联系人电话:">
                                <span>{{ props.row.urgent_phone }}</span>
                            </el-form-item>
                            <el-form-item label="家庭地址:">
                                <span>{{ props.row.address }}</span>
                            </el-form-item>
                        </div>

                        <div class="more-style">
                            <el-form-item label="所属城市:">
                                <span>{{ props.row.city.name }}</span>
                            </el-form-item>
                            <el-form-item label="极光编码:">
                                <span>{{ props.row.registration_id }}</span>
                            </el-form-item>
                            <el-form-item> </el-form-item>
                        </div>

                        <div>
                            <el-form-item label="备注:">
                                <span>{{ props.row.remarks }}</span>
                            </el-form-item>
                        </div>

                        <div>
                            <el-form-item label="系统备注:">
                                <span>{{ props.row.system_remarks }}</span>
                            </el-form-item>
                        </div>
                    </el-form>
                </template>
            </el-table-column>

            <!-- <el-table-column prop="id" label="id" min-width="80">
            </el-table-column> -->

            <el-table-column prop="name" label="司机名称" min-width="140">
                <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top">
                        <p>司机编码: {{ scope.row.driver_code }}</p>
                        <div slot="reference">
                            <el-tag size="medium" style="border: 0; background-color: #fff; color: #333">{{ scope.row.name }} </el-tag>
                        </div>
                    </el-popover>
                </template>
            </el-table-column>

            <el-table-column prop="real_name" label="真实姓名" min-width="140"> </el-table-column>

            <el-table-column prop="level.alias" label="司机等级" min-width="140">
                <template slot-scope="scope">
                    <span> Lv.{{ scope.row.level.lv }} </span>
                </template>
            </el-table-column>

            <el-table-column prop="phone" label="手机电话" min-width="150"> </el-table-column>

            <el-table-column prop="driver_points.signing_end_time.YmdHis" label="签约到期时间" min-width="150">
               
            </el-table-column>

            <el-table-column label="身份" min-width="80">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.capacity.val == '0' ? 'danger' : scope.row.capacity.val == '1' ? '' : 'warning'">
                        {{ scope.row.capacity.alias }}
                    </el-tag>
                </template>
            </el-table-column>

            <!-- <el-table-column label="工作类型" min-width="80">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.driver_or_legwork == '0' ? '' : 'warning'">
                        {{ scope.row.driver_or_legwork == '0' ? '代驾司机' : '跑腿骑手' }}
                    </el-tag>
                </template>
            </el-table-column> -->

            <el-table-column label="管理状态" min-width="80">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status.val == '0' ? 'warning' : scope.row.status.val == '1' ? '' : 'danger'">
                        {{ scope.row.status.alias }}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column prop="balance" label="钱包余额" min-width="150">
                <template slot-scope="scope">
                    <span style="color: rgb(233, 161, 6)">
                        {{ scope.row.balance }}
                    </span>
                    元
                </template>
            </el-table-column>

            <!-- <el-table-column prop="balance" label="签约规则" min-width="150">
                <template slot-scope="scope">

                      {{scope.row.driver_points.signing_type== '0'?'按天签约':'按月签约'}}


                </template>
            </el-table-column>

            <el-table-column label="警示灯" min-width="150">
                <template slot-scope="scope">
                    <img src="../../../assets/yellow.png" alt="" style="width: 20px;height: 20px;" v-if="scope.row.alarm == 1">
                    <img src="../../../assets/red.png" alt="" style="width: 20px;height: 20px;" v-if="scope.row.alarm == 2">
                </template>
            </el-table-column> -->

            <el-table-column label="操作" min-width="150">
                <template slot-scope="scope">
                    <el-dropdown
                        split-button
                        type="primary"
                        @click="
                            edit_isShow = !edit_isShow;
                            driver_code_children = scope.row.driver_code;
                        "
                        trigger="click"
                    >
                        编辑

                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="untying(scope.row.driver_code)">解绑设备</el-dropdown-item>

                            <el-dropdown-item
                                @click.native="
                                    editPassword_show = !editPassword_show;
                                    driver_code_children = scope.row.driver_code;
                                "
                            >
                                修改密码
                            </el-dropdown-item>

                            <el-dropdown-item
                                @click.native="
                                    determine_isShow = !determine_isShow;
                                    driver_code_children = scope.row.driver_code;
                                "
                            >
                                审核判定
                            </el-dropdown-item>
                            <!-- <el-dropdown-item @click.native="open(scope.row.driver_code)"> 保险审核 </el-dropdown-item> -->

                            <!-- <el-dropdown-item @click.native="toSigning(scope.row.driver_code)" v-if="driver_deduct_day=='1' && scope.row.driver_or_legwork == '0'">
                                续费签约
                            </el-dropdown-item> -->

                            <el-dropdown-item
                                @click.native="toSigningLegwork(scope.row.driver_code)"
                                v-if="driver_signing_date == '1' && scope.row.driver_or_legwork == '1'"
                            >
                                签约骑手
                            </el-dropdown-item>

                            <el-dropdown-item
                                v-if="driver_deduct_day == '1'"
                                @click.native="toSubSigning(scope.row)"
                            >
                                扣除签约天数
                            </el-dropdown-item>

                            <!-- <el-dropdown-item
                              @click.native="wallet_isShow =!wallet_isShow; driver_code_children = scope.row.driver_code;">司机钱包
                            </el-dropdown-item> -->

                            <el-dropdown-item
                                @click.native="
                                    capital_isShow = !capital_isShow;
                                    driver_code_children = scope.row.driver_code;
                                    driver_name = scope.row.name;
                                    driver_phone = scope.row.phone;
                                "
                            >
                                司机资金流水
                            </el-dropdown-item>

                            <el-dropdown-item
                                v-if="driver_signing_date == '1'"
                                @click.native="
                                    data_isShow = !data_isShow;
                                    driver_code_children = scope.row.driver_code;
                                    driver_or_legwork = scope.row.driver_or_legwork;
                                    driver_name = scope.row.name;
                                    driver_phone = scope.row.phone;
                                "
                            >
                                调整签约日期
                            </el-dropdown-item>
                            <el-dropdown-item
                                v-if="driver_job == '1'"
                                @click.native="
                                    SigningType_isShow = !SigningType_isShow;
                                    driver_code_children = scope.row.driver_code;
                                    driver_or_legwork = scope.row.driver_or_legwork;
                                    driver_name = scope.row.name;
                                    driver_phone = scope.row.phone;
                                    signing_type = scope.row.driver_points.signing_type;
                                "
                            >
                                调整签约类型
                            </el-dropdown-item>
                            <!-- <el-dropdown-item

                                @click.native="
                                    SigningType_isShow = !SigningType_isShow;
                                    driver_code_children = scope.row.driver_code;
                                    driver_or_legwork = scope.row.driver_or_legwork;
                                    driver_name = scope.row.name;
                                    driver_phone = scope.row.phone;
                                "
                            >
                                调整签约类型测试用
                            </el-dropdown-item> -->

                            <el-dropdown-item
                                @click.native="
                                    grabbing_isShow = !grabbing_isShow;
                                    driver_code_children = scope.row.driver_code;
                                    driver_name = scope.row.name;
                                "
                            >
                                司机抢单记录
                            </el-dropdown-item>

                            <el-dropdown-item
                                @click.native="
                                    driverTime_isShow = !driverTime_isShow;
                                    driver_code_children = scope.row.driver_code;
                                    driver_name = scope.row.name;
                                "
                            >
                                司机上线记录
                            </el-dropdown-item>

                            <el-dropdown-item
                                @click.native="
                                    driverAchievement_isShow = !driverAchievement_isShow;
                                    driver_code_children = scope.row.driver_code;
                                "
                            >
                                司机业绩信息
                            </el-dropdown-item>

                            <el-dropdown-item
                                v-if="driver_driverpoints_add == '1'"
                                @click.native="
                                    editRank_isShow = !editRank_isShow;
                                    driver_code_children = scope.row.driver_code;
                                "
                            >
                                修改司机段位
                            </el-dropdown-item>

                            <!-- <el-dropdown-item
                              @click.native="online_isShow =!online_isShow; driver_code_children = scope.row.driver_code; driver_name = scope.row.name;driver_phone = scope.row.phone;">
                              司机上下线时间
                            </el-dropdown-item> -->
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>

        <!-- 批量删除按钮 -->
        <!-- <el-button type="primary" icon="el-icon-delete" class="handle-del mr10" @click="deleteData"
          style="margin-top: 20px;">批量删除</el-button> -->

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>

        <!-- 修改密码组件 -->
        <editPassword :isShow="editPassword_show" @onSubmit="driverLists" :data="driver_code_children"></editPassword>

        <!-- 添加组件 -->
        <addDriverDrawer :isShow="add_isShow" @onSubmit="addDriverSubmit"></addDriverDrawer>
        <!-- 时间段司机资金流水组件 -->
        <!-- <waterDriverDrawer :isShow="water_isShow"></waterDriverDrawer> -->

        <!-- 编辑组件 -->
        <editDriverDrawer :isShow="edit_isShow" :data="driver_code_children" @onSubmit="driverLists"></editDriverDrawer>

        <!-- 添加优享司机组件 -->
        <enjoyDriver :data="driver_code_children" :isShow="enjoy_isShow" @onSubmit="driverLists"></enjoyDriver>

        <!-- 续费签约组件 -->
        <!-- <signing :data="driver_code_children" :isShow="signing_isShow"
                 @onSubmit="driverLists"></signing> -->

        <!--        签约骑手      -->
        <signingLegwork :data="driver_code_children" :isShow="signingLegwork_isShow" @onSubmit="driverLists"></signingLegwork>
        <!-- 扣除签约天数组件 -->
        <subSigning
            :data="driver_code_children"
            :isShow="subSigning_isShow"
            :driver_or_legwork="driver_or_legwork"
            @onSubmit="driverLists"
        ></subSigning>

        <!-- 司机钱包组件 -->
        <!-- <driverWallet :data="driver_code_children" :isShow="wallet_isShow"></driverWallet> -->

        <!-- 审核判定组件 -->
        <toDetermine :data="driver_code_children" :isShow="determine_isShow" @onSubmit="driverLists"></toDetermine>

        <!-- 司机抢单记录组件 -->
        <driverGrabbing :data="driver_code_children" :isShow="grabbing_isShow" :name="driver_name"></driverGrabbing>

        <!-- 司机资金流水组件 -->
        <driverCapitalFlow
            :data="driver_code_children"
            :isShow="capital_isShow"
            :driverName="driver_name"
            :driverPhone="driver_phone"
            @onSubmit="driverLists"
        ></driverCapitalFlow>

        <!-- 调整签约日期组件 -->
        <driverChangeData
            :data="driver_code_children"
            :driverName="driver_name"
            :driver_or_legwork="driver_or_legwork"
            :driverPhone="driver_phone"
            :isShow="data_isShow"
        ></driverChangeData>
        <!-- 调整司机签约类型组件 -->
        <editSigningType
            :data="driver_code_children"
            :driverName="driver_name"
            :driver_or_legwork="driver_or_legwork"
            :driverPhone="driver_phone"
            :isShow="SigningType_isShow"
            :signing_type="signing_type"
            @onSubmit="driverLists"
        ></editSigningType>

        <!-- 司机上下线时间 -->
        <!-- <driverOnlineTime :data="driver_code_children" :isShow="online_isShow" :driverName="driver_name"
          :driverPhone="driver_phone">
        </driverOnlineTime> -->

        <!-- 司机上下线 -->
        <driverTime
            :data="driver_code_children"
            :isShow="driverTime_isShow"
            :driverName="driver_name"
            :driverPhone="driver_phone"
        ></driverTime>

        <!-- 司机业绩信息组件 -->
        <driverAchievement :isShow="driverAchievement_isShow" :data="driver_code_children"></driverAchievement>

        <!-- 修改段位组件 -->
        <editRank :isShow="editRank_isShow" @onSubmit="driverLists" :data="driver_code_children"></editRank>
    </div>
</template>

<script>
var _this;
import editSigningType from './editSigningType.vue';
import addDriverDrawer from './addDriverDrawer.vue';
import editPassword from './editPassword.vue';
import editDriverDrawer from './editDriverDrawer.vue';
import enjoyDriver from './enjoyDriver.vue';
import signing from './signing.vue';
import driverWallet from './driverWallet.vue';
import toDetermine from '../determine/toDetermine.vue';
// import driverRecord from './driverRecord.vue';
import subSigning from './subSigning.vue';
import signingLegwork from './signingLegwork.vue';

import driverCapitalFlow from './driverCapitalFlow.vue';
import driverChangeData from './driverChangeData.vue';
// import driverOnlineTime from './driverOnlineTime.vue';
import driverGrabbing from './driverGrabbing.vue';
import driverTime from './driverTime.vue';
import driverAchievement from './driverAchievement.vue';
import editRank from './editRank.vue';
import bus from '../../common/bus.js';

export default {
    components: {
        addDriverDrawer,
        editPassword,
        editDriverDrawer,
        enjoyDriver,
        signing,
        driverWallet,
        toDetermine,
        // driverRecord,
        subSigning,
        driverCapitalFlow,
        driverChangeData,
        // driverOnlineTime,
        driverGrabbing,
        driverTime,
        driverAchievement,
        editRank,
        signingLegwork,
        editSigningType,

    },
    data() {
        return {
            SigningType_isShow: false,
            signing_type: '',
            driver_signing_date: JSON.parse(localStorage.getItem('login')).driver_signing_date,
            driver_deduct_day: JSON.parse(localStorage.getItem('login')).driver_deduct_day,
            driver_job: JSON.parse(localStorage.getItem('login')).driver_job,




            driver_driverpoints_add: JSON.parse(localStorage.getItem('login')).driver_driverpoints_add,
            driver_sign_add: JSON.parse(localStorage.getItem('login')).driver_sign_add,

            editRank_isShow: false,

            subSigning_isShow: false,

            signingLegwork_isShow: false,

            // 司机资金流水组件开关
            capital_isShow: false,

            //调整签约日期开关
            data_isShow: false,

            // 司机上下线开关
            driverTime_isShow: false,

            // 司机业绩信息组件开关
            driverAchievement_isShow: false,

            // 司机抢单记录组件
            grabbing_isShow: false,

            // 修改密码开关
            editPassword_show: false,

            driver_or_legwork: '',

            // 司机名称
            driver_name: '',

            //司机电话
            driver_phone: '',

            // 选项卡默认选中项
            activeName: 'all',

            // 传入子组件的数据
            driver_code_children: '',

            //详细搜索
            more_search: false,

            // 批量删除
            delDriverSubmit_data: {
                driver_code_array: []
            },
            delDriverSubmit_rules: {
                driver_code_array: {
                    placeholder: '权限模块',
                    rules: {
                        required: false,
                        message: '权限模块代码数组(json)',
                        regulation: 'special',
                        rulesData: 'json_array'
                    }
                }
            },

            // 抽屉开关按钮
            edit_isShow: false,
            add_isShow: false,

            //  优享司机开关
            enjoy_isShow: false,

            // 续费签约组件开关
            signing_isShow: false,

            // 司机钱包组件开关
            wallet_isShow: false,

            // 司机账单组件开关
            record_isShow: false,

            // 审核判定开关
            determine_isShow: false,
            determine_drawer: '',

            //司机上下线开关
            online_isShow: false,

            // 下拉搜索性别
            value_sex_code: '',
            val_sex_array: '',
            val_capacity_array: [],

            // 下拉搜索管理状态
            value_status_code: '',
            value_status_array: [],

            // 存放表格数据
            tableData: [],

            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                name: '',
                phone: '',
                sex: '',
                status: '',
                real_name: '',
                id_card: '',
                insurance_alarm: '',
                signing_type: '',

            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;

        _this.driverLists();

        // 接收子组件传来的事件并初始化列表
        bus.$on('onSubmit', (msg) => {
            _this.driverLists();
        });
    },

    methods: {
        toSubSigning(val) {
            console.log(1212121212);
            _this.subSigning_isShow = !_this.subSigning_isShow;
            _this.driver_code_children = val.driver_code;
            _this.driver_or_legwork = val.driver_or_legwork;
        },

        toSigningLegwork(driverCode) {
            _this.signingLegwork_isShow = !_this.signingLegwork_isShow;
            _this.driver_code_children = driverCode;
        },

        toSigning(driverCode) {
            _this.signing_isShow = !_this.signing_isShow;
            _this.driver_code_children = driverCode;
        },

        searchDriverLists() {
            _this.search_data.page = 1;
            _this.driverLists();
        },

        // 选项卡选中事件
        handleClick(tab, event) {
            // 点击的选项卡所对应的val值
            console.log(tab.name);
            if (tab.name != 'all') {
                _this.search_data.status = tab.name;
            } else {
                _this.search_data.status = '';
            }
            _this.search_data.page = 1;
            _this.driverLists();
        },

        // 添加司机成功
        addDriverSubmit() {
            _this
                .$post(
                    '/driver/driverLists',
                    {
                        page: 1,
                        limit: 10,
                        name: '',
                        phone: '',
                        sex: '',
                        status: ''
                    },
                    _this.search_rules
                )
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    console.log(_this.tableData,'_this.tableData添加司机成功');
                    _this.result_data = res;
                })
                .catch((err) => {});
        },

        // 搜索司机列表
        driverLists() {
            _this
                .$post('/driver/driverLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    console.log(_this.tableData,'_this.tableData列表');

                    _this.result_data = res;
           

                    _this.val_sex_array = _this.tableData[0].sex.select_array;
                    _this.capacity = _this.tableData[0].capacity.select_array;
                    _this.value_status_array = _this.tableData[0].status.select_array;
                    console.log(1111);
                })
                .catch((err) => {});
        },

        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.driverLists();
        },

        handleSelectionChange(val) {
            var datalist = [];

            for (var i in val) {
                datalist.push(val[i].driver_code);
            }
            _this.delDriverSubmit_data.driver_code_array = datalist;
        },

        // 批量删除
        deleteData() {
            if (_this.delDriverSubmit_data.driver_code_array.length == 0) {
                _this.$message.error({
                    message: '请至少勾选一条数据',
                    duration: 1500
                });
                return;
            }

            _this
                .$confirm('此操作将删除该条数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',

                    cancelButtonText: '取消',

                    type: 'warning'
                })
                .then(() => {
                    _this.delDriverSubmit_data.driver_code_array = JSON.stringify(_this.delDriverSubmit_data.driver_code_array);

                    _this
                        .$post('/driver/delDriverSubmit', _this.delDriverSubmit_data, _this.delDriverSubmit_rules)
                        .then((res) => {
                            _this.$message.success({
                                message: '删除成功',
                                duration: 1500
                            });
                            //初始化显示列表
                            _this.driverLists();
                        })
                        .catch((err) => {});
                })
                .catch(() => {
                    _this.$message({
                        message: '已取消删除',
                        duration: 1500
                    });
                });
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        },

        // 解绑设备
        untying(code) {
            _this
                .$confirm('此操作将解绑该条数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',

                    cancelButtonText: '取消',

                    type: 'warning'
                })
                .then(() => {
                    _this
                        .$post('/driver/untyingDriverMobileSubmit', {
                            driver_code: code
                        })
                        .then((res) => {
                            _this.$message.success({
                                message: '解绑设备成功',
                                duration: 1500
                            });
                            _this.driverLists();
                        })
                        .catch((err) => {});
                })
                .catch(() => {});
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>
